import { render, staticRenderFns } from "./CardProviderSettings.vue?vue&type=template&id=b9c34a0c&scoped=true"
import script from "./CardProviderSettings.vue?vue&type=script&lang=ts"
export * from "./CardProviderSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c34a0c",
  null
  
)

export default component.exports